import { makeObservable, observable, action, runInAction } from 'mobx';
import { useLocalObservable } from 'mobx-react-lite';
import { MouseEvent, KeyboardEvent } from 'react';

export const useOverlay = () =>
  useLocalObservable(() => ({
    anchor: null as HTMLElement | null,
    isOpen: false,

    handleClick(e: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>) {
      this.isOpen = true;
      this.anchor = e.currentTarget;
    },

    handleClose() {
      this.isOpen = false;
      this.anchor = null;
    }
  }));
export class OverlayViewModel<TItem> {
  item?: TItem;
  isOpen = false;
  anchor?: HTMLElement;
  loading = false;
  open(item: TItem, anchor: HTMLElement) {
    this.item = item;
    this.anchor = anchor;
    this.isOpen = true;
  }
  async openAsync(getItem: () => Promise<TItem>, anchor: HTMLElement) {
    this.loading = true;
    this.isOpen = true;
    this.anchor = anchor;
    const item = await getItem();
    runInAction(() => {
      this.item = item;
      this.loading = false;
    });
  }

  close() {
    this.isOpen = false;
  }

  constructor() {
    makeObservable(this, {
      item: observable,
      loading: observable,
      isOpen: observable,
      anchor: observable,
      open: action,
      openAsync: action,
      close: action
    });
  }
}

export const useOverlay2 = <TItem,>() => new OverlayViewModel<TItem>();
